import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import CustomLoader from "../component/loader/Loader";

const AuthLayout = () => {
  const storeData = useSelector((state) => state.mainReducer);
  const { userData, isLoading } = storeData;
  const navigate = useNavigate();
  useEffect(() => {
    // need a logic here a user comes from if user not entered from this route,
    // it means that user is not authenticated user, he entered here bypass..
    if (userData) {
      // navigate("/app");
      if (userData.role === "MASTER") {
        navigate("/app");
      }
    }
  }, [userData, navigate]);

  return !userData && isLoading === "userData" ? <CustomLoader /> : <Outlet />;
};
export default AuthLayout;
